import { render } from "./MyDownloadCodes.vue?vue&type=template&id=af8e78a8&scoped=true"
import script from "./MyDownloadCodes.vue?vue&type=script&lang=js"
export * from "./MyDownloadCodes.vue?vue&type=script&lang=js"

import "./MyDownloadCodes.vue?vue&type=style&index=0&id=af8e78a8&lang=scss&scoped=true"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8e78a8"]])

export default __exports__